import { getClasses } from "../../utils";
import classes from "./DataField.module.css";

type Props = {
  name: string;
  data?: string | number | JSX.Element;
  className?: string;
};

const DataField: React.FC<Props> = ({ name, data, className = "" }) => {
  return (
    <div className={getClasses(classes.main, className)}>
      <div className={classes.name}>{name}</div>
      {data && <div className={classes.data}>{data}</div>}
    </div>
  );
};

export default DataField;
